<template>
  <div class="container">
    <div class="ruleicon" @click="rulePopupShow = true">规则</div>

    <!-- <img class="toplogo" src="@/assets/img2/logo-white.png" /> -->
    <div class="notice">
      <img class="icon" src="@/assets/img2/venueone-icon1.png" />
      <van-notice-bar scrollable :text="'连续签到奖励：连续签到 3 天、7 天可额外获得1次领好礼机会'" />
    </div>

    <img class="fdkh" src="@/assets/img2/venueone-fdkh.png" />
    <img class="fdkhtime" src="@/assets/img2/venueone-fdkhtime.png" />

    <div class="fdbox">
      <div class="fdbg">
        <img class="fd fd1" src="@/assets/img2/venueone-fd.png" alt="">
        <img class="fd fd2" src="@/assets/img2/venueone-fd.png" alt="">
        <img class="icon fxkfd" @click="sharePopupShow = true" src="@/assets/img2/venueone-fxkfd.png" alt="">
        <img class="fd fd3" src="@/assets/img2/venueone-fd.png" alt="">
        <img class="icon wdjp" @click="openMyprice" src="@/assets/img2/venueone-wdjp.png" alt="">
      </div>
      <div class="fdbottom">
        <div class="numbox">
          <div class="circle"></div>
          <div>共{{ num }}次开福袋机会</div>
          <div class="circle"></div>
        </div>
      </div>
    </div>

    <div class="pricebox">
      <img class="pricetitle" src="@/assets/img2/venueone-pricetitle.png" alt="">
      <div class="pricecon">
        <img class="priceimg" src="@/assets/img2/venueone-priceexam.png" alt=""></img>
        <img class="priceimg" src="@/assets/img2/venueone-priceexam.png" alt=""></img>
        <img class="priceimg" src="@/assets/img2/venueone-priceexam.png" alt=""></img>
        <img class="priceimg" src="@/assets/img2/venueone-priceexam.png" alt=""></img>
        <img class="priceimg" src="@/assets/img2/venueone-priceexam.png" alt=""></img>
        <img class="priceimg" src="@/assets/img2/venueone-priceexam.png" alt=""></img>
      </div>
    </div>

    <!-- 结果弹框 -->
    <van-popup v-model="resultPopupShow" position="center" :close-on-click-overlay="false"
      class="custom-popup-mhresult">
      <div class="popupbg">
        <img class="topimg" src="@/assets/img2/popup-topzj.png" alt="">
        <diV class="popup-wrapper">
          <div class="popup-content">
            <div class="top">
              <img class="icon" src="@/assets/img2/popup-iconL.png" alt="">
              <diV class="name">{{ productName }}</diV>
              <img class="icon" src="@/assets/img2/popup-iconR.png" alt="">
            </div>

            <img class="jpimg" src="@/assets/img2/popup-hd1.png" alt="">
            <div class="btnbox">
              <img class="btn" src="@/assets/img2/popup-btn1.png" alt="" @click="resultPopupShow = false">
              <img class="btn" src="@/assets/img2/popup-btn2.png" alt="">
              <!-- <img class="btn" src="@/assets/img2/popup-btn3.png" alt=""> -->
            </div>
          </div>
        </diV>
      </div>
    </van-popup>

    <!-- 奖品弹框 -->
    <van-popup v-model="pricePopupShow" @close="pricePopupShow = false" class="custom-popup-myprice">
      <div class="price-box">
        <div class="noReward">我的奖品</div>
        <template v-if="myPriceList.length != 0">
          <div class="tips">
            <div>奖品已发放至您的账户</div>
            <div>紫金保险公众号-个人中心-我的卡劵，查看使用</div>
          </div>
          <div class="priceH">
            <div class="rulesBox" v-for="(item, index) in myPriceList" :key="index">
              <div class="imgbox">
                <img v-if="item.productDetail" :src="item.productDetail" alt="" mode="aspectFit" />
                <img v-else src="@/assets/img2/price-mr.png" alt="" mode="aspectFit" />
              </div>
              <div class="infoBox">
                <div>{{ item.productName }}
                  <span v-if="item.nm > 1"> &nbsp;&nbsp;&nbsp;&nbsp;x {{ item.nm }}</span>
                </div>
              </div>
            </div>
          </div>
        </template>
        <div v-else>
          <div class="noPrice">
            <img src="@/assets/img2/later2x.png" alt="">
            <div class="msg">暂无奖品</div>
          </div>
        </div>
        <!-- <div class="commBtn" @click="againFn">去使用</div> -->
      </div>
    </van-popup>

    <!-- 关注公众号 -->
    <van-popup v-model="gzhPopupShow" position="center" :close-on-click-overlay="false" class="custom-popup-gzh">
      <img class="topimg" src="@/assets/img2/home-popup-top.png" alt="">
      <div class="popup-content">
        <img class="titleimg" src="@/assets/img2/home-popup-title3.png" alt="">
        <img class="logo" src="@/assets/img2/logo.png" alt="">
        <img class="ewm" :src="gzhImg" alt="">
        <div class="des">（长按关注紫金保险官方公众号参与活动）</div>
      </div>
    </van-popup>

    <!-- 活动规则 -->
    <van-popup v-model="rulePopupShow" position="center" :close-on-click-overlay="false"
      class="custom-popup-gzh custom-popup-rule">
      <img class="topimg" src="@/assets/img2/home-popup-top.png" alt="">
      <div class="popup-content">
        <img class="titleimg" src="@/assets/img2/home-popup-title2.png" alt="">
        <div class="textbox">
          <div class="text">
            1.紫金保险会员每日登录可获得1次免费开福袋机会；
          </div>
          <div class="text">
            2.点击福袋，福袋打开，弹出对应奖品；
          </div>
          <div class="text">
            3.连续签到奖励：连续签到 3 天、7 天可额外获得 1 次开福袋机会;
          </div>
          <div class="text">
            4.分享奖励：分享活动给好友，好友参与后分享者额外获得 1 次机会
          </div>
        </div>
        <img class="btn" src="@/assets/img2/home-btn.png" alt="" @click="rulePopupShow = false">
      </div>
    </van-popup>

    <!-- 分享 -->
    <van-popup v-model="sharePopupShow" position="center" :close-on-click-overlay="false"
      class="custom-popup-gzh custom-popup-share">
      <img class="topimg" src="@/assets/img2/home-popup-top.png" alt="">
      <div class="popup-content">
        <img class="titleimg" src="@/assets/img2/home-popup-title1.png" alt="">
        <div class="textbox">
          <div class="text">
            1.点击右上角【…】图标
          </div>
          <img class="shareexample" src="@/assets/img2/home-share-example.png" alt="">
          <div class="text">
            2.点击“转发给朋友”按钮即可将活动分享给好友
          </div>
          <div class="text">
            3.好友参与后即可额外获得 1 次机会开福袋机会，可返回小程序查看
          </div>
        </div>
        <img class="btn" src="@/assets/img2/home-btn.png" alt="" @click="sharePopupShow = false">
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getPersonApi, userPoints, zfLj, getActApi, postConfigApi, trackingMonitor, loginApi, shareApi, myPrice } from '@/api/index'

import { getPageLlq } from '@/utils/index.js'
export default {
  components: {},
  data() {
    return {
      num: 0,
      rulePopupShow: false,
      gzhPopupShow: false,
      gzhImg: require('@/assets/img2/' + process.env.VUE_APP_ZKING_GZHIMG + '.png'),
      resultPopupShow: false,
      sharePopupShow: false,

      productName: '金龙鱼礼盒',

      pricePopupShow: false,
      myPriceList: [
        // {
        //   productDetail: 'https://zj518-1325888264.cos.ap-nanjing.myqcloud.com/product-pic/ff5d2f3c3f23713071fa89e38702324.png',
        //   productName: '视频会员周卡(腾讯、优酷、搜狐、芒果四选一)',
        // },
        // {
        //   productDetail: 'https://zj518-1325888264.cos.ap-nanjing.myqcloud.com/product-pic/zpbt.png',
        //   productName: '视频季卡'
        // },
        // {
        //   productDetail: 'https://zj518-1325888264.cos.ap-nanjing.myqcloud.com/product-pic/100%E5%85%83%E4%BF%9D%E5%85%BB%E5%8A%B5a.png',
        //   productName: '视频季卡'
        // },
      ],
    }
  },
  created() {
    console.log('venueone页面参数',this.$route.query);
    this.pageLlq = getPageLlq()
    // 判断链接中是否含有token
    if (this.$route.query.return_zking_info) {
      loginApi({
        utoken: this.$route.query.return_zking_info,
      }).then((res) => {
        localStorage.setItem('Authorization', res.data.accessToken)

        this.getActData()

        this.getzfLj()
        this.getPersonData()
      });
    } else {
      this.getActData()

      this.getzfLj()
      this.getPersonData()
    }
  },

  mounted() {
    this.getzfList()
  },

  methods: {
    // 我的奖品
    openMyprice() {
      myPrice().then(res => {
        this.myPriceList = res.data
        this.pricePopupShow = true
      })
    },
    // 获取活动信息
    getActData() {
      getActApi().then((res) => {
        this.actType = res.data

        // 启动定时器，每2秒调用一次 fetchData
        this.intervalId = setInterval(this.getuserPoints, 2500);
        // 首次加载立即调用一次
        this.getuserPoints();

        if (this.actType == '01') {
          trackingMonitor('A004').then((res) => { });
        } else {
          trackingMonitor('A009').then((res) => { });
        }

      });
    },

    // 获取个人信息
    getPersonData() {
      getPersonApi().then((res) => {
        if (res.code == 1006000000) {
          // 关注公众号
          this.gzhPopupShow = true
          trackingMonitor('A003').then((res) => { });
        } else {
          this.gzhPopupShow = false
        }
        this.zkToken = res.data.zkToken


      });
    },

    getuserPoints() {
      userPoints().then(res => {
        this.chances = res.data.chances
        this.points = res.data.points
        this.dailyBlessingSy = res.data.dailyBlessingSy
        this.allZf = res.data.allZf

        if (localStorage.getItem('lovenum')) {
          this.totalAx = res.data.totalAx - 1
          setTimeout(() => { this.showgif = true }, 100)
          setTimeout(() => {
            this.showgif = false
            this.totalAx = res.data.totalAx
            localStorage.removeItem('lovenum')
          }, 2000)
        } else {
          this.totalAx = res.data.totalAx
        }
      })
    },






  },

  beforeDestroy() {
  },
}
</script>

<style lang="less" scoped>
.container {
  padding: 9px 0 20px 0;
  background: linear-gradient(180deg, #8833EF 0%, #B675F8 50.86%, #ECCAFA 100%);

  display: flex;
  flex-direction: column;
  align-items: center;

  .toplogo {
    width: 100px;
    height: 20px;
    margin-left: 10px;
  }

  .notice {
    width: 342px;
    height: 32px;
    padding: 0 15px 0 40px;
    box-sizing: border-box;
    background: rgba(245, 230, 255, 0.37);
    box-shadow: inset 0px 0px 16px 13px rgba(255, 255, 255, 0.5);
    border-radius: 16px 16px 16px 16px;
    border: 1px solid rgba(255, 255, 255, 0.6);
    margin: 12px auto;
    position: relative;

    .icon {
      width: 43px;
      height: 43px;
      top: -6px;
      left: -8px;
      position: absolute;
    }

    .van-notice-bar {
      width: 100%;
      height: 100%;
      background-color: transparent;
      padding: 0;
      font-weight: 500;
      font-size: 13px;
      color: #6935A3;
    }
  }

  .fdkh {
    width: 232px;
  }

  .fdkhtime {
    margin-top: 5px;
    width: 300px;
  }

  .fdbox {
    width: 100%;

    .fdbg {
      width: 100%;
      height: 350px;
      padding-top: 25px;
      box-sizing: border-box;
      background-size: 100% 100%;
      background-image: url(../assets/img2/venueone-fdbg.png);
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      .fd {
        width: 152px;
        height: 158px;
        transform-origin: center center;
      }

      .fd1 {
        margin-right: 30px;
        /* 先执行 fadeInLeft (2s)，再执行 scalePulse (1.5s, 无限循环) */
        animation: fadeInLeft 2s ease-out forwards, scalePulse 2s ease-in-out infinite 2s;
        opacity: 0;
      }

      .fd2 {
        animation: fadeInRight 2s ease-out forwards, scalePulse 2s ease-in-out infinite 2s;
        opacity: 0;
        /* 初始隐藏 */
      }

      .fd3 {
        margin: 0 13px;
        animation: fadeInUp 2s ease-out forwards, scalePulse 2s ease-in-out infinite 2s;
        opacity: 0;
      }

      // 从左侧淡入
      @keyframes fadeInLeft {
        from {
          opacity: 0;
          transform: translateX(-50px) scale(1);
        }

        to {
          opacity: 1;
          transform: translateX(0) scale(1);
        }
      }

      // 从右侧淡入
      @keyframes fadeInRight {
        from {
          opacity: 0;
          transform: translateX(50px) scale(1);
        }

        to {
          opacity: 1;
          transform: translateX(0) scale(1);
        }
      }

      // 从下方向上淡入
      @keyframes fadeInUp {
        from {
          opacity: 0;
          transform: translateY(50px) scale(1);
        }

        to {
          opacity: 1;
          transform: translateY(0) scale(1);
        }
      }

      // 新增：缩放脉冲效果 (轻微放大缩小)
      @keyframes scalePulse {
        0% {
          transform: scale(1);
        }

        50% {
          transform: scale(1.1);
          /* 放大到 1.05 倍 */
        }

        100% {
          transform: scale(1);
        }
      }

      .icon {
        width: 87px;
        height: 56px;
        margin-top: 88px;
      }
    }

    .fdbottom {
      width: 100%;
      height: 80px;
      background-size: 100% 100%;
      background-image: url(../assets/img2/venueone-fdbottom.png);
      display: flex;
      justify-content: center;

      .numbox {
        width: 183px;
        height: 36px;
        margin-top: 4px;
        background: #A759FF;
        box-shadow: inset 0px 4px 5px 0px rgba(255, 255, 255, 0.4);
        border-radius: 10px 10px 10px 10px;
        border: 1px solid #FFFFFF;
        font-family: HelloFont WenYiHei, HelloFont WenYiHei;
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
        display: flex;
        justify-content: center;
        align-items: center;

        .circle {
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background-color: #fff;
          margin: 7px;
        }
      }
    }
  }

  .pricebox {
    margin-top: -2px;
    background: #FFF5CB;
    display: flex;
    flex-direction: column;
    align-items: center;


    .pricetitle {
      width: 194px;
      margin: 10px auto;
    }

    .pricecon {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;

      .priceimg {
        width: 106px;
        height: 108px;
        margin: 9px 7px;
      }
    }

  }



  .custom-popup-myprice {
    width: 340px !important;
    border-radius: 14px 14px 14px 14px;
    background: linear-gradient(180deg, #fffdf4 0%, #fff6d4 100%);

    .price-box {
      padding-bottom: 30px;

      .noReward {
        text-align: center;
        margin: 24px 0 0 0;
        font-family: Inter, Inter;
        font-weight: bold;
        font-size: 22px;
        color: #000000;
        line-height: 28px;
      }

      .priceH {
        max-height: 430px;
        overflow-y: auto;
      }

      .rulesBox {
        margin: 0 19px 6px 17px;
        background: #ffffff;
        border-radius: 7px 7px 7px 7px;
        padding: 7px 11px 7px 7px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .imgbox {
          width: 70px;
          height: 70px;
          background: #eee9ff;
          border-radius: 4px;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 100%;
          }
        }

        .infoBox {
          font-weight: 400;
          font-size: 14px;
          color: #000000;
          width: 200px;
        }
      }

      .commBtn {
        margin: 30px auto 30px;
        width: 230px;
        height: 56px;
        // padding:14px 0 0 136px ;
        box-sizing: border-box;
        background-image: url("https://zj518-1325888264.cos.ap-nanjing.myqcloud.com/commBtn.png");
        background-size: cover;
        font-family: Inter, Inter;
        font-weight: 500;
        font-size: 18px;
        color: #52405c;
        line-height: 56px;
        text-align: center;
      }
    }

    .noPrice {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 22px;

      img {
        width: 200px;
      }

      .msg {
        font-size: 16px;
        color: #000000;
      }
    }

    .tips {
      text-align: center;
      // font-size: 16px;
      margin: 14px 0 12px 0;
    }
  }
}
</style>
